import { render, staticRenderFns } from "./WishListCount.vue?vue&type=template&id=47aca3c9&"
import script from "./WishListCount.vue?vue&type=script&lang=js&"
export * from "./WishListCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22413/203/Snaply5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47aca3c9')) {
      api.createRecord('47aca3c9', component.options)
    } else {
      api.reload('47aca3c9', component.options)
    }
    module.hot.accept("./WishListCount.vue?vue&type=template&id=47aca3c9&", function () {
      api.rerender('47aca3c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/snaply/WishListCount.vue"
export default component.exports